<template>
  <v-select
      v-model="selectedItem"
      :placeholder="placeholder"
      :label="label"
      clearable
      solo
      dense
      filled
      :items="searchResult"
      :item-text="item => item.code + ' - ' + item.name"
      :item-value="itemValue"
      :no-data-text="
                searchText
                  ? searchLoading
                    ? 'Lütfen Bekleyin'
                    : searchText.length < 3
                    ? 'En az 3 karakter girmelisiniz'
                    : 'Sonuç Bulunamadı'
                  : 'Arama yapmak için kutucuğu doldurun'
              "
  >
    <template v-slot:prepend-item>
      <v-list-item>
        <v-list-item-content>
          <v-text-field clearable v-model="searchTerm" placeholder="Arama Yapın..."
                        @input="filterOptions"></v-text-field>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-select>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  components: {},
  props: {
    presentItems: {
      type: Array,
      default: null,
    },
    itemValue: {
      type: String,
      default: 'code',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    searchType: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState("auth", ["user"]),

  },
  data() {
    return {
      selectedItem: null,
      searchText: null,
      searchLoading: false,
      searchResult: [],
      searchTimeout: null,
      searchTerm: "",
    };
  },
  methods: {
    ...mapActions("current", ["fetchSalesPersonList", "fetchCurrentList"]),
    ...mapActions("stock", ["fetchStockList"]),
    ...mapActions("project", ["fetchProjectListBySearch"]),
    ...mapActions("order",["getPendingOrdersSupplier"]),


    filterOptions(searchTerm) {
      switch (this.searchType) {
        case 'current':
          if (searchTerm.length >= 3) {
            this.searchText = searchTerm;
            this.searchCurrentList();
          }
          break;
        case 'stock':
          if (searchTerm.length >= 3) {
            this.searchText = searchTerm;
            this.searchStockList();
          }
          break;
        case 'project':
          this.searchText = searchTerm;
          this.searchProjectList();
          break;
        case 'supplier':
          this.searchText = searchTerm;
          this.searchSupplierList();
          break;
        case 'withData':
          this.searchText = searchTerm;
          this.searchPresentData();
          break;
      }
    },
    async searchCurrentList() {
      this.searchLoading = true;
      this.searchResult = await this.fetchCurrentList({
        params: {
          userId: this.user.UserId,
          pageNumber: 1,
          pageSize: 50,
          ...((this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2
              ? true
              : false) && {salesPersonCode: this.user.SalesPersonCode}),
          ...((this.searchText == "" || this.searchText == null
              ? false
              : true) && {searchText: this.searchText})
        },
        body: {},
        onlyData: true,
        loading: false
      });
      this.searchLoading = false;
    },
    async searchStockList() {
      this.searchLoading = true;
      this.searchResult = await this.fetchStockList({
        params: {
          pageNumber: 1,
          pageSize: 30,
          userId: this.user.UserId,
        },
        body: {
          stock: this.searchText,
          GenericCategories: null
        },
        onlyData: true,
        loading: false
      });
      this.searchLoading = false
    },
    async searchProjectList() {
      this.searchLoading = true;
      this.searchResult = await this.fetchProjectListBySearch({
        params: {
          userId: this.user.UserId,
          searchText: this.searchText
        },
        body: {},
      });
      this.searchLoading = false
    },
    async searchPresentData() {
      this.searchResult = this.presentItems.filter(item =>
          item.name.toLowerCase().includes(this.searchText.toLowerCase()) || item.code.toLowerCase().includes(this.searchText.toLowerCase())
      );
    },

    async searchSupplierList(){
      this.searchLoading = true;
      this.searchResult = await this.getPendingOrdersSupplier({
        params:{
          searchText: this.searchText
        },
        body: {},
      });
    }
  },
  watch: {
    selectedItem: function (newVal) {
      this.$emit("itemChange", newVal);
    }
  }
}
</script>